export default {
    appName: 'Fox-Spotify',
    platform: 'Web',
    generated_playlist_name: "FOX",
    callbackUri: "quiz",
    AUTHENTICATION_SUCCESS: "authentication_success",
    spotifyUser: "bcvlh4cxnlv48qh4ai6rb9p0k",
    COOKIE_AUTH: "spotify_authorization",
    facebook_share_url: "https://www.facebook.com/sharer/sharer.php?u={url}",
    twitter_share_url: "https://twitter.com/share?url={url}&amp;text=Faz%20o%20quiz%20e%20descobre%20que%20estrela%20FOX%20podia%20partilhar%20casa%20contigo",
    spotify_url: "https://play.spotify.com/user/{userId}/playlist/{playlistId}",

    playlists: {
        steve: "1JDMlcCThHY2oHswi5DDGg",
        jack: "5aiF8ncphm9axdOHPaMJh4",
        meredith: "3VO7VtmS2u1uE00sY0j7XH",
        earn: "28qgSlov6TLdJq6dmzOjg1",
        gloria: "0WBsHwOvKSlLnJYHHwo5uV",
        peter: "2XiWWYKn7ftumsBrROeGE6",
        barney: "6oteFd2miOZcdL8EqFkee9",
        rick: "6eaaULJbGz6eGrJ7W41ABO",
        negan: "3rDMxjUYwFtRFpNoHZi4ov"
    },

    //Fique bem ciente que isto é um objecto à parte porque foi pedido no fim e perdi a paciência para por isto no objecto anterior. Blame someone else
    playlistsURL: {
        steve: "https://open.spotify.com/user/bcvlh4cxnlv48qh4ai6rb9p0k/playlist/1JDMlcCThHY2oHswi5DDGg?si=FmR2bxlSSoiZFkFvxgpW1g",
        jack: "https://open.spotify.com/user/bcvlh4cxnlv48qh4ai6rb9p0k/playlist/5aiF8ncphm9axdOHPaMJh4?si=Rv4dHiqfR-yFJv_ioCEAqA",
        meredith: "https://open.spotify.com/user/bcvlh4cxnlv48qh4ai6rb9p0k/playlist/3VO7VtmS2u1uE00sY0j7XH?si=TiBB0cH-TfimIeumPHR7Kg",
        earn: "https://open.spotify.com/user/bcvlh4cxnlv48qh4ai6rb9p0k/playlist/28qgSlov6TLdJq6dmzOjg1?si=6T-oMX4lTdSu1z9R2HMy4w",
        gloria: "https://open.spotify.com/user/bcvlh4cxnlv48qh4ai6rb9p0k/playlist/0WBsHwOvKSlLnJYHHwo5uV?si=9ysBUlFxSLmIlG1EfTSWvQ",
        peter: "https://open.spotify.com/user/bcvlh4cxnlv48qh4ai6rb9p0k/playlist/2XiWWYKn7ftumsBrROeGE6?si=x1yWn8KARFO8F0f62QMqHw",
        barney: "https://open.spotify.com/user/bcvlh4cxnlv48qh4ai6rb9p0k/playlist/6oteFd2miOZcdL8EqFkee9?si=68ln_vaeRayi1VvZ6qforg",
        rick: "https://open.spotify.com/user/bcvlh4cxnlv48qh4ai6rb9p0k/playlist/6eaaULJbGz6eGrJ7W41ABO?si=JY5G3ZQZSMCZ-WxUtnyl4Q",
        negan: "https://open.spotify.com/user/bcvlh4cxnlv48qh4ai6rb9p0k/playlist/3rDMxjUYwFtRFpNoHZi4ov?si=VoySTm8zTM2QwujZm6NAxw"
    },    

    playlistData: {
        "1JDMlcCThHY2oHswi5DDGg": {
            title: "Steve McGarrett",
            title2: "YEAAH!",
            h4:
                "Tu e a estrela de Hawai Força Especial na mesma casa vai ser épico.",
            p:
                "Viveu grande parte da sua vida rodeado de praia, sol e mar. Com todo o seu treino militar e policial é a pessoa certa para te fazer sentir seguro dentro de quatro paredes. Até porque o Steve é o tipo que quebra as regras que tiver de quebrar para proteger família e amigos – e housemates, claro. ",
            playlistTitle: "A playlist do McGarret vai mexer contigo.",
            img: 'slide2'
        },
        "5aiF8ncphm9axdOHPaMJh4": {
            title: "Jack Pearson",
            title2: "COOL!",
            h4:
                "Tu e a estrela do This Is Us na mesma casa vai ser só marcar pontos.",
            p:
                "O Jack é capaz de transformar a tua sala numa minibancada VIP para ver jogos. É o companheiro ideal para serões de futebol, apesar de preferir futebol americano. Jack é o verdadeiro lumberjack apaixonado pela sua amada e família. É só pontos a favor. ",
            playlistTitle: "A playlist inspirada no Jack tem tudo a ver contigo.",
            img: 'slide6'
        },
        "3VO7VtmS2u1uE00sY0j7XH": {
            title: "Meredith Grey",
            title2: "Wow!",
            h4:
                "Tu e a estrela de Anatomia de Grey na mesma casa têm tudo para dar certo.",
            p:
                "Fica já o aviso: tu e a Meredith vão dar-se lindamente, desde que tenham quartos separados e bem longe um do outro - é que ela ressona imenso... Mas para noites cheias de emoções, dança e muita tequila também podes contar ela.",
            playlistTitle: "A playlist da Meredith é mesmo a tua cara.",
            img: 'slide3'
        },
        "28qgSlov6TLdJq6dmzOjg1": {
            title: "Earnest ‘Earn’ Banks",
            title2: "DUDE!",
            h4:
                "Tu e a estrela de Atlanta na mesma casa é mesmo uma sintonia perfeita.",
            p:
                "Não vais encontrar ninguém melhor do que o Earn para aqueles longos serões de conversas no sofá. Especialmente se o tema for música. Earn sonha bem alto e tenta entrar no mercado musical como manager. Mas, acima de tudo, é um companheiro cheio de SWAG!",
            playlistTitle: "A playlist do Earn vai ficar logo no teu ouvido.",
            img: 'slide9'
        },
        "0WBsHwOvKSlLnJYHHwo5uV": {
            title: "Gloria Pritchett",
            title2: "Que bien!",
            h4:
                "Tu e a estrela de Uma Família Muito Moderna na mesma casa vai ser uma fiesta.",
            p:
                "Temperamental, explosiva, a Glória é a verdadeira diva latina, orgulhosa das suas raízes colombianas. E como qualquer diva vai precisar de muito espaço lá em casa. Porque gosta de brilhar e ofuscar as outras mulheres. A Glória é super expressiva e não te vais querer chatear com ela.",
            playlistTitle: "A playlist inspirada na Gloria tem tudo a ver contigo.",
            img: 'slide1'
        },
        "2XiWWYKn7ftumsBrROeGE6": {
            title: "Peter Griffin",
            title2: "LOL",
            h4:
                "Tu e a estrela de Family Guy na mesma casa vai ter imensa piada.",
            p:
                "O Peter vai ser um grande companheiro de sofá. Ele é aquele teu amigo um pouco idiota que fala pelos cotovelos. E no meio da conversa vais acabar por perceber que tem uma inteligência e capacidade de concentração reduzidas. Mas para binge watching é o melhor compincha, pois é capaz de passar horas frente à TV.",
            playlistTitle: "A playlist inspirada no Peter tem tudo a ver contigo.",
            img: 'slide5'
        },
        "6oteFd2miOZcdL8EqFkee9": {
            title: "Barney Stinson",
            title2: "YOU ROCK!",
            h4:
                "Tu e a estrela de Foi Assim Que Aconteceu na mesma casa tem tudo para ser perfeito.",
            p:
                "O Barney é perfeito em muita coisa. Se for para “sacar” miúdas então... é o perfeito wingman! Mulherengo sem remédio é capaz de inventar as maiores histórias e mentiras para conseguir o que quer, mas é super leal e está sempre pronto a ajudar toda a gente.",
            playlistTitle: "A playlist inspirada no Barney tem tudo a ver contigo.",
            img: 'slide8'
        },
        "6eaaULJbGz6eGrJ7W41ABO": {
            title: "Rick Grimes",
            title2: "YEAHHH!",
            h4:
                "Tu e a estrela de The Walking Dead na mesma casa vai ser incrível.  ",
            p:
                "Se procuras alguém que faça tudo por ti em casa, o Rick é a tua escolha... Mas também pode ser um pouco aborrecido pelo seu grande sentido de justiça e pelo seu código moral. Muita atenção na hora de dividir tarefas, não te deixes levar.",
            playlistTitle: "Vais mesmo vibrar com a playlist do Rick.",
            img: 'slide4'
        },
        "3rDMxjUYwFtRFpNoHZi4ov": {
            title: "Negan",
            title2: "QUE BADASS!",
            h4:
                "És dos poucos que poderiam partilhar casa com a estrela de The Walking Dead.",
            p:
                "É preciso ter um grande estofo para viver com o Negan. Pode ser complicado lidar com a sua personalidade mais manipuladora. Tens de estar sempre com “um olho no padre e outro na missa” … Não é um companheiro de casa para qualquer um.",
            playlistTitle: "A playlist do Negan não é para todos.",
            img: 'slide7'
        }
    },

    questions: [
        {
            question: "Em que cidade",
            questionHighlight: "gostavas de viver?",
            answers: [
                {
                    label: "Seattle, EUA",
                    value: "meredith"
                },
                {
                    label: "Atlanta, EUA",
                    value: "rick,earn,negan"
                },
                {
                    label: "Los Angeles, EUA",
                    value: "jack,gloria"
                },
                {
                    label: "Nova Iorque, EUA",
                    value: "barney"
                },
                {
                    label: "Honolulu, Havai",
                    value: "steve"
                },
                {
                    label: "Quahog, Rhode Island, EUA",
                    value: "peter"
                }
            ]
        },
        {
            question: "Qual a divisão da casa",
            questionHighlight: "que mais gostas?",
            answers: [
                {
                    label: "Quarto",
                    value: "barney"
                },
                {
                    label: "Sala",
                    value: "peter,earn"
                },
                {
                    label: "Jardim/Terraço",
                    value: "negan,rick"
                },
                {
                    label: "Cozinha",
                    value: "jack"
                },
                {
                    label: "Ginásio",
                    value: "steve"
                },
                {
                    label:
                        "Gostas de espaço, por isso toda a casa é importante",
                    value: "gloria"
                }
            ]
        },
        {
            question: "Que tipo de companheiro de casa",
            questionHighlight: " gostavas de ter?",
            answers: [
                {
                    label: "Animado qb e muito responsável",
                    value: "meredith,steve"
                },
                {
                    label: "Protetor(a) e “caseirinho/a”",
                    value: "rick,jack"
                },
                {
                    label: "Muito social e cheio/a de “pinta”",
                    value: "earn,gloria"
                },
                {
                    label: "Super divertido/a, mas distraído/a ",
                    value: "peter"
                },
                {
                    label: "Um(a) party animal cheio/a de amigos/as",
                    value: "barney"
                },
                {
                    label:
                        "Um(a) anti-social que gosta de estar sozinho",
                    value: "negan"
                }
            ]
        },
        {
            question: "Como é o teu",
            questionHighlight: "fim de semana ideal?",
            answers: [
                {
                    label: "Fazer maratonas televisivas",
                    value: "peter"
                },
                {
                    label: "Ir ao bar com os amigos",
                    value: "barney"
                },
                {
                    label: "Dançar",
                    value: "meredith,gloria"
                },
                {
                    label: "Praticar desportos de luta",
                    value: "negan,steve"
                },
                {
                    label: "Ir a jogos de futebol ",
                    value: "jack"
                },
                {
                    label: "Ouvir muita música",
                    value: "earn"
                }
            ]
        },
        {
            question: "Achas-te capaz de…",
            answers: [
                {
                    label: "Surfar nas maiores ondas",
                    value: "steve"
                },
                {
                    label: "Mentir para engatar miúdas/rapazes",
                    value: "barney"
                },
                {
                    label: "Matar um zombie",
                    value: "negan,rick"
                },
                {
                    label: "Criar e educar quíntuplos",
                    value: "jack,meredith"
                },
                {
                    label: "Desafinar em frente a milhares de pessoas",
                    value: "gloria,earn,peter"
                },
                {
                    label: "Fazer uma operação para retirar o apêndice",
                    value: "meredith"
                }
            ]
        }
    ]
};
